import api from './api';

// Get all users (Super Admin only)
export const getUsers = async () => {
    const response = await api.get('/users');
    return response.data;
};

// Get user by ID
export const getUser = async (id) => {
    const response = await api.get(`/users/${id}`);
    return response.data;
};

// Create user (Super Admin only)
export const createUser = async (userData) => {
    const response = await api.post('/users', userData);
    return response.data;
};

// Update user
export const updateUser = async (id, userData) => {
    const response = await api.put(`/users/${id}`, userData);
    return response.data;
};

// Delete user (Super Admin only)
export const deleteUser = async (id) => {
    const response = await api.delete(`/users/${id}`);
    return response.data;
};